var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappycoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2222_12463)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27659 18.3763H9.76495C14.2057 18.3763 17.8115 14.8387 17.8115 10.4821C17.8115 6.12547 14.2057 2.58786 9.76495 2.58786",
    fill: "#AA7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9875 16.4636L13.5518 16.4822L14.5288 15.48L16.0105 15.4575L14.9875 16.465V16.4636Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5293 16.8433L13.0435 16.8605L12.2168 17.3649L13.9285 17.2375L14.5293 16.8433Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0632 7.15573L15.5193 7.06812C15.361 6.70042 14.7818 5.85087 14.3569 5.38095L16.0105 5.50839C16.3596 5.96104 16.8264 6.69909 17.0632 7.15573Z",
    fill: "#F3E9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27666 18.3763C3.83266 18.3763 0.230087 14.842 0.230087 10.4821C0.230087 6.12223 3.83266 2.58786 8.27666 2.58786C12.7207 2.58786 16.3232 6.12223 16.3232 10.4821C16.3232 14.842 12.7207 18.3763 8.27666 18.3763Z",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27666 18.3763C3.83266 18.3763 0.230087 14.842 0.230087 10.4821C0.230087 6.12223 3.83266 2.58786 8.27666 2.58786C12.7207 2.58786 16.3232 6.12223 16.3232 10.4821C16.3232 14.842 12.7207 18.3763 8.27666 18.3763Z",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09304 10.4823C2.32711 4.20226 8.30759 3.88898 8.22099 3.88898C4.51093 3.88898 1.5004 6.84385 1.5004 10.4823C1.5004 14.1208 4.51229 17.0757 8.22099 17.0757C8.30759 17.0757 2.20399 16.7186 2.09304 10.4823Z",
    fill: "#A67705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27643 17.13C4.53411 17.13 1.50036 14.1537 1.50036 10.4823C1.50036 6.81079 4.53411 3.83448 8.27643 3.83448C12.0187 3.83448 15.0525 6.81079 15.0525 10.4823C15.0525 14.1537 12.0187 17.13 8.27643 17.13Z",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.27659 18.3763H9.76495C14.2057 18.3763 17.8115 14.8387 17.8115 10.4821C17.8115 6.12547 14.2057 2.58786 9.76495 2.58786",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76514 2.58786H8.27668",
    stroke: "#0B1420",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0056 1.53661C10.6362 1.12776 9.84732 0.871565 9.15181 1.06006",
    stroke: "black",
    strokeWidth: 0.78476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75168 1.9028C5.06155 1.44882 5.80714 1.09041 6.52295 1.18599",
    stroke: "black",
    strokeWidth: 0.78476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0016 11.2295C10.0016 11.2295 9.01384 11.803 7.96793 11.7286C6.92202 11.6543 5.98842 11.3198 5.98842 11.3198C5.98842 11.3198 5.80711 12.6286 6.54182 13.8233C7.27652 15.018 7.94493 15.2344 8.63769 15.1202C9.33045 15.006 10.1693 14.2468 10.4548 13.0441C9.98803 12.6233 9.75801 11.86 9.99886 11.2295H10.0016Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0344 11.1953C8.79909 11.8457 7.37568 11.8895 5.95228 11.3997C5.96175 11.7515 5.97663 12.0674 6.04023 12.3926C6.62339 12.9939 8.8018 12.982 9.94242 12.1816C9.83282 11.8643 9.89777 11.5789 10.0344 11.1953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34968 14.3675C8.43628 14.1857 8.56213 13.9574 8.9383 13.8897C9.44167 13.7994 9.80566 14.1472 9.80566 14.1472C9.80566 14.1472 9.53503 14.9158 8.57701 15.0512C7.59733 15.1905 7.27664 14.4313 7.27664 14.4313C7.27664 14.4313 7.34565 14.1671 7.67852 14.0224C7.92073 13.9175 8.21978 13.956 8.49988 14.1074",
    fill: "#FF7EB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.34968 14.3675C8.43628 14.1857 8.56213 13.9574 8.9383 13.8897C9.44167 13.7994 9.80566 14.1472 9.80566 14.1472C9.80566 14.1472 9.53503 14.9158 8.57701 15.0512C7.59733 15.1905 7.27664 14.4313 7.27664 14.4313C7.27664 14.4313 7.34565 14.1671 7.67852 14.0224C7.92073 13.9175 8.21978 13.956 8.49988 14.1074",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7429 10.4824C12.1245 10.0258 10.7971 10.1041 10.2071 10.9032C9.2491 12.1988 10.7809 13.6643 11.8025 13.8873",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0344 11.1952C8.50277 12.0421 6.8737 11.904 5.15804 10.9031",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4614 13.0456C10.2544 13.8872 9.59142 15.0885 8.40073 15.1204C6.60659 15.1695 5.81235 12.5226 6.00043 11.3266",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.01315 10.315C5.95427 10.315 5.09588 9.25472 5.09588 7.94684C5.09588 6.63895 5.95427 5.5787 7.01315 5.5787C8.07203 5.5787 8.93042 6.63895 8.93042 7.94684C8.93042 9.25472 8.07203 10.315 7.01315 10.315Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52539 9.76149C8.34001 9.57698 7.95301 9.22787 7.46858 9.15751C6.90162 9.07521 6.38607 9.25441 6.22369 9.68981C6.0126 10.258 6.47267 10.9363 7.18578 11.1168C7.52 11.2018 7.91918 11.1872 8.25747 11.0332",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.52539 9.76149C8.34001 9.57698 7.95301 9.22787 7.46858 9.15751C6.90162 9.07521 6.38607 9.25441 6.22369 9.68981C6.0126 10.258 6.47267 10.9363 7.18578 11.1168C7.52 11.2018 7.91918 11.1872 8.25747 11.0332",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75949 10.315C8.70061 10.315 7.84222 9.25472 7.84222 7.94684C7.84222 6.63895 8.70061 5.5787 9.75949 5.5787C10.8184 5.5787 11.6768 6.63895 11.6768 7.94684C11.6768 9.25472 10.8184 10.315 9.75949 10.315Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.19552,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.68362 7.04169C9.19649 7.04169 8.80002 7.53019 8.80002 8.13284C8.80002 8.7355 9.19514 9.22399 9.68362 9.22399C10.1437 9.22399 10.4915 8.75143 10.5239 8.47267L9.74587 8.1209L10.5104 7.74789C10.4468 7.42001 10.1139 7.04169 9.68362 7.04302V7.04169Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00027 6.86766C6.51314 6.86766 6.11667 7.35615 6.11667 7.9588C6.11667 8.56146 6.51179 9.04995 7.00027 9.04995C7.46034 9.04995 7.8081 8.57739 7.84058 8.29863L7.06252 7.94686L7.82704 7.57385C7.76345 7.24597 7.43057 6.86766 7.00027 6.86898V6.86766Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2222_12463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappycoin);
export default __webpack_public_path__ + "static/media/happycoin.8d8965eb15c1756ad026f6d3b1811447.svg";
export { ForwardRef as ReactComponent };